import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';
import { LIST_NOTIFICATION } from '../../apiCalls/urls/notification';
import { GET_LIST } from '../../apiCalls/urls/common';
export const notificationApi = createApi({
    baseQuery,
    tagTypes: ['notification'],
    reducerPath: 'notificationApi',
    endpoints: (builder) => ({
        getNotificationList: builder.query({
            query: (bodyData) => ({
                url: LIST_NOTIFICATION,
                method: 'POST',
                body: bodyData || {} 
            }),
            providesTags: ['notification'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetNotificationListQuery,
    useGetListMutation
} = notificationApi;